/**
 * Common Page Module
 * Code that runs on all pages
 */

import { initNavigation } from "../modules/navigation.js";
import {
  initLogoCarousel,
  initCardImageSlider,
  initFocusModuleSlider,
  initEditorialModuleSlider,
  initSideContentStoriesSlider,
  initTimelineSlider,
} from "../modules/carousels.js";
import { initAccordion, initAccordionDynamic } from "../modules/accordions.js";
import {
  initSideContentBrand,
  initCardSDGModule,
  initLaunchTextWithModal,
  initLaunchTextModal,
  initLeadershipTeam,
  initContentModuleTopModals,
} from "../modules/modals.js";
import {
  initSideContentVideo,
  initMediaImageVideo,
  initMediaVideoAutoplay,
} from "../modules/videos.js";
import {
  initCardImageSliderFilter,
  initMediaFilters,
} from "../modules/filters.js";
import {
  initHomeHeroParallax,
  initMapSection,
  initSideContentSticky,
  initMediaImageTextScroll,
} from "../modules/animations.js";
import { initTimelineScroll } from "../modules/timelineScroll.js";
import { initScrollDown } from "../modules/scrollDown.js";
import { initCertificationsTable } from "../modules/certifications.js";
import { initTabs } from "../modules/tabs.js";
import { init as initDropdowns } from "../modules/dropdowns.js";
import { initShare } from "../modules/share.js";

export const common = {
  init() {
    // Navigation (runs on all pages)
    initNavigation();

    // Tabs (replaces Bootstrap tabs functionality)
    initTabs();

    // Dropdowns (replaces Bootstrap dropdowns functionality)
    initDropdowns();

    // Carousels (check existence inside each function)
    initLogoCarousel();
    initCardImageSlider();
    initFocusModuleSlider();
    initEditorialModuleSlider();
    initSideContentStoriesSlider();
    initTimelineSlider();

    // Accordions
    initAccordion();
    initAccordionDynamic();

    // Modals
    initSideContentBrand();
    initCardSDGModule();
    initLaunchTextWithModal();
    initLaunchTextModal();
    initLeadershipTeam();
    initContentModuleTopModals();

    // Videos
    initSideContentVideo();
    initMediaImageVideo();
    initMediaVideoAutoplay();

    // Filters
    initCardImageSliderFilter();
    initMediaFilters();

    // Animations
    initHomeHeroParallax();
    initMapSection();
    initSideContentSticky();
    initMediaImageTextScroll();
    initScrollDown();
    initTimelineScroll();

    // Certifications
    initCertificationsTable();

    // Share buttons
    initShare();

    document.body.classList.add("page-loaded");
  },

  finalize() {
    // Code to run after page-specific JS
  },
};
